module.exports = __webpack_public_path__ + "img/Express_Delivery.971b0014.svg";